import { NgStyle } from "@angular/common";
import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { MoodsDistributionBarService } from "./moods-distribution-bar.service";
import { Mood } from "../timeline-item";
import { MoodForCalendar } from "../../calendar/calendar.type";

@Component({
    selector: 'tm-moods-distribution-bar',
    templateUrl: './moods-distribution-bar.component.html',
    imports: [
        MatTooltipModule,
        NgStyle,
        TranslateModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        MoodsDistributionBarService
    ]
})
export class MoodsDistributionBarComponent implements OnChanges {
    
    @Input() moods: Mood[] | MoodForCalendar[];
    data: { 
        excellent: { value: number; percentage: string; label: string; number: number; };
        good: { value: number; percentage: string; label: string; number: number;  };
        average: { value: number; percentage: string; label: string; number: number;  };
        hard: { value: number; percentage: string; label: string; number: number;  };
        bad: { value: number; percentage: string; label: string; number: number;  };
    };

    constructor(
        private moodsDistributionBarService: MoodsDistributionBarService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.data = this.moodsDistributionBarService.updatePercentage(changes.moods.currentValue)
    }
}
   
